<ll-titulo>{{ titulo }}</ll-titulo>
<plan-clase-alumno-new [planPersonalId]="planEstudioId" [baseRoute]="baseRoute" [vistaPrevia]="vistaPrevia">
</plan-clase-alumno-new>